import {Box, FormControl, Grid, MenuItem, Select, TextField, Typography} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {LifecycleMail, TransactionalMail} from "crqlar-react-common/dist/models/newsletter/newsletterMail";
import {LifeCycleMailType, TransactionalMailType} from "crqlar-react-common/dist/models/newsletter/newsletterMailType";
import {NewsletterMailType} from "crqlar-react-common/dist/models/newsletter/newsletterMailType";

interface Props {
    handleNext: () => void
    activeStep: number
    onCloseDialog: () => void,
    newsletterMail?: LifecycleMail | TransactionalMail,
    setNewsletterMail: (newsletterMail: LifecycleMail | TransactionalMail) => void
    mailTypes: LifeCycleMailType[] | TransactionalMailType[]
}

const MailContent = (props: Props) => {

    const {t} = useTranslation()

    return (
        <Box>
            <Grid container spacing={4} sx={{mb: 5}}>
                <Grid item md={6}>
                    <FormControl fullWidth>
                        <Typography>
                            {props.newsletterMail?.type === NewsletterMailType.LIFECYCLE
                                ? t('Lifecycle Mail')
                                : t('Transactional Mail')
                            }
                        </Typography>
                        <Select
                            value={props.newsletterMail?.subType || props.mailTypes[0]}
                            onChange={(e) =>
                                props.setNewsletterMail({
                                    ...props.newsletterMail,
                                    subType: e.target.value
                                })
                            }
                        >
                            {props.mailTypes.map((mailType) => (
                                <MenuItem key={mailType} value={mailType}>{mailType}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item md={6} sx={{mt: 2}}>
                    <TextField
                        label={t("Name")}
                        value={props.newsletterMail?.name || ''}
                        onChange={(e) =>
                            props.setNewsletterMail({
                                ...props.newsletterMail,
                                name: e.target.value
                            })
                        }
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

export default MailContent
